import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import GridScan from "../components/GridScan";
import "../CSS/Signup.css";

const Signup = () => {
  const navigate = useNavigate();

  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    username: "",
    email: "",
    password: "",
    confirmPassword: "",
  });

  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = async (e) => {

    /* 
    //Gauri code

    e.preventDefault();
    setError(null);

    if (formData.password !== formData.confirmPassword) {
      setError("Passwords do not match");
      return;
    }

    const payload = {
      firstName: formData.firstName,
      lastName: formData.lastName,
      email: formData.email,
      username: formData.username,
      password: formData.password,
      clientId: "seeragro",
      realm: "navaantrix",
      emailVerified: true,
    };

    try {
      setLoading(true);

      await axios.post(
        "https://admin-portal-kc.navaantrix.com/keycloak/api/users/signupUser",
        payload,
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      // Success → redirect to login
      navigate("/login");
    } catch (err) {
      console.error(err);
      setError(
        err.response?.data?.message || "Signup failed. Please try again."
      );
    } finally {
      setLoading(false);
    } 
      */

    //onkar code
e.preventDefault();
  setError(null);

  if (formData.password !== formData.confirmPassword) {
    setError("Passwords do not match");
    return;
  }

  // x-www-form-urlencoded payload
  const payload = new URLSearchParams();
  payload.append("firstName", formData.firstName);
  payload.append("lastName", formData.lastName);
  payload.append("email", formData.email);
  payload.append("username", formData.username);
  payload.append("password", formData.password);
  payload.append("clientId", "seeragro");
  payload.append("realm", "navaantrix");
  payload.append("emailVerified", "true");

  try {
    setLoading(true);

    await axios.post(
      "https://admin-portal-kc.navaantrix.com/keycloak/api/users/signupUser",
      payload,
      {
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
        },
      }
    );

    // Signup success → go to login
    navigate("/login");

  } catch (err) {
    console.error(err);
    setError(
      err.response?.data?.message ||
      "Signup failed. Please try again."
    );
  } finally {
    setLoading(false);
  }
  };

  return (
    <div className="login-page">
      {/* Background */}
      <div className="login-bg">
        <GridScan
          sensitivity={0.55}
          lineThickness={1}
          linesColor="#392e4e"
          gridScale={0.1}
          scanColor="#FF9FFC"
          scanOpacity={0.4}
          enablePost
          bloomIntensity={0.6}
          chromaticAberration={0.002}
          noiseIntensity={0.01}
        />
      </div>

      {/* Signup Card */}
      <div className="login-card signup-card">
        <h2>Create Account</h2>
        <p className="subtitle">Sign up to manage your account</p>

        <form onSubmit={handleSubmit}>
          <input
            type="text"
            name="firstName"
            placeholder="First Name"
            value={formData.firstName}
            onChange={handleChange}
            required
          />

          <input
            type="text"
            name="lastName"
            placeholder="Last Name"
            value={formData.lastName}
            onChange={handleChange}
            required
          />

          <input
            type="text"
            name="username"
            placeholder="Username"
            value={formData.username}
            onChange={handleChange}
            required
          />

          <input
            type="email"
            name="email"
            placeholder="Email"
            value={formData.email}
            onChange={handleChange}
            required
          />

          <input
            type="password"
            name="password"
            placeholder="Password"
            value={formData.password}
            onChange={handleChange}
            required
          />

          <input
            type="password"
            name="confirmPassword"
            placeholder="Confirm Password"
            value={formData.confirmPassword}
            onChange={handleChange}
            required
          />

          {error && <p className="form-error">{error}</p>}

          <button type="submit" className="login-btn" disabled={loading}>
            <span>{loading ? "CREATING..." : "SIGN UP"}</span>
            <span className="arrow"> → </span>
          </button>

          <p className="signup-link" onClick={() => navigate("/login")}>
            Already have an account? Login
          </p>
        </form>
      </div>
    </div>
  );
};

export default Signup;
 